import { parse, serialize } from 'parse5'

export function validateAndFixHtml(
  label: string,
  rawHtml: string
): { html: string; isValid: boolean } {
  try {
    // Wrap style tags content with .page-wrapper-css
    if (label === 'head_html') {
      rawHtml = rawHtml.replace(
        /(<style[^>]*>)([\s\S]*?)(<\/style>)/gi,
        (_, openTag, content, closeTag) => {
          return `${openTag}.page-wrapper-css{${content}}${closeTag}`
        }
      )
    }

    const parsed = parse(rawHtml)
    const fixedHtml = serialize(parsed)

    const normalize = (html: string) =>
      html.replace(/\s+/g, '').replace(/["']/g, '').toLowerCase()

    const rawNormalized = normalize(rawHtml)
    const fixedNormalized = normalize(fixedHtml)

    const isValid = rawNormalized === fixedNormalized

    if (!isValid) {
      console.warn(
        `⚠️ [${label}] HTML bị chỉnh sửa khi parse. Có thể có lỗi như thiếu thẻ đóng.`
      )
    }

    return {
      html: fixedHtml,
      isValid,
    }
  } catch (err) {
    console.error(`❌ [${label}] HTML parse lỗi nghiêm trọng:`, err)
    return {
      html: rawHtml,
      isValid: false,
    }
  }
}
